<template>
  <div>
    <div v-if="loading" class="box-loading d-flex justify-content-center">
      <div class="loading f30 py-2">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
      </div>
    </div>
    <div id="webviewer" ref="viewer"></div>
  </div>
</template>

<script>
  import WebViewer from '@pdftron/webviewer'

  export default {
    name: 'WebViewer',
    props: {
      url: String,
    },
    mounted: function () {
      this.loading = true
      const path = `${process.env.BASE_URL}webviewer`
      const url = new URL(this.$route.query.url ?? this.url)
      WebViewer(
        {
          path,
          initialDoc: url.href.replace('+', '%2B'),
          isReadOnly: true,
          // enableAnnotations:   false,
          autoFocusNoteOnAnnotationSelection: false,
          disableVirtualDisplayMode: true,
        },
        this.$refs.viewer
      ).finally(() => {
        this.loading = false
      })
    },
    data() {
      return {
        loading: false,
      }
    },
  }
</script>

<style>
  #webviewer {
    height: 100vh;
  }
</style>
